import { gql } from '@apollo/client';

export const QUERY = gql`
  query GetStubOrgByTsPersistentUuid($tsPersistentUuid: ID!) {
    getStubOrgByTsPersistentUuid(tsPersistentUuid: $tsPersistentUuid) {
      id
      name
      ownerFirstName
      ownerLastName
      ownerEmail
      country
      businessType
      plan
      numberOfTeamsPaidFor
      mailingAddress
      zipCode
      timezone
      sport
    }
  }
`;
